<div>
  <div class="flex flex-col gap-5">
    <div *ngFor="let row of chartConfigs" class="flex flex-col md:flex-row w-full gap-5">
      <div *ngFor="let config of row" class="w-full md:w-1/2">
        <p-card styleClass="p-4">
          <ng-template pTemplate="header">
            <h3>{{ config.title }}</h3>
          </ng-template>
          <app-google-analytics-graph
            [chartId]="config.chartId"
            [currencyFormat]="config.currencyFormat"
            [beginAtZero]="config.beginAtZero"
            [stepSize]="config.stepSize"
            [backgroundColor]="config.backgroundColor"
            [foregroundColor]="config.foregroundColor">
          </app-google-analytics-graph>
        </p-card>
      </div>
    </div>
  </div>
</div> 